const round = (x: number) => Math.round(x);

export default round;
